import moment from 'moment';
import BigNumber from 'bignumber.js';
export const getYesterdayPickerDate = () => [
    moment().subtract(1, 'days').toISOString().slice(0, 10)
];
export const getWeekPickerDate = () => [
    moment().subtract(6, 'days').toISOString().slice(0, 10),
    moment().toISOString().slice(0, 10)
];
export const getMonthPickerDate = () => [
    moment().subtract(29, 'days').toISOString().slice(0, 10),
    moment().toISOString().slice(0, 10)
];
export const getCorrectAmountHistoryItem = (item) => (Object.assign(Object.assign({}, item), { amount: BigNumber(item.amount).abs() }));
